import React, { useMemo, useState, useEffect, useCallback, useReducer } from 'react';
import { v4 as uuidv4 } from 'uuid';
import {
	TranslatedString,
	LocallySortedAndPaginatedTable,
	makeLocallySortedAndPaginatedTableColumnHeader,
	useAjax,
	XhrStatus,
	PrimaryButton,
	InputField,
	DateTimePicker,
	Card,
	formUpdateFieldValues,
	Checkbox,
	Dropdown,
	CommandBar
} from '@bosch/bt-ui';
import 'react-datepicker/dist/react-datepicker.css';
import './SimActivationDetailPage.css';
import withErrorHandler from '../../components/ErrorHandler';
import RestfulCallout from '../../components/RestfulCallout';
import RestfulCallLoading from '../../components/RestfulCallLoading';
import fileDownload from 'js-file-download';
import RadioOptions from './RadioComponent/RadioOptions';
import { prepareLogData } from '../../components/Util';

const convertUTCHours = (hours) => {
	if (parseInt(hours) > 0) {
		return -Math.abs(hours);
	}
	else {
		return Math.abs(hours);
	}
}

const getEstOffset = () => {
	const stdTimezoneOffset = () => {
		var jan = new Date(0, 1)
		var jul = new Date(6, 1)
		return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset())
	}

	var today = new Date();

	const isDstObserved = (today) => {
		return today.getTimezoneOffset() < stdTimezoneOffset()
	}
	console.log(isDstObserved(today));

	if (isDstObserved(today)) {
		return 4
	} else {
		return 5
	}
}


const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
var timezoneOffset = currentTimeZone === 'America/New_York' ? convertUTCHours(getEstOffset()).toString() : convertUTCHours(new Date().getTimezoneOffset() / 60).toString();
timezoneOffset = parseInt(timezoneOffset) > 0 ? '+' + timezoneOffset : timezoneOffset;

const TABLE_HEADERS = [
	makeLocallySortedAndPaginatedTableColumnHeader('SimId', 'Sim ID'),
	makeLocallySortedAndPaginatedTableColumnHeader('Status', 'Status'),
	makeLocallySortedAndPaginatedTableColumnHeader('StatusDescription', 'Status Description'),
	makeLocallySortedAndPaginatedTableColumnHeader('Date', 'Date(UTC +00:00)'),
	makeLocallySortedAndPaginatedTableColumnHeader('LocalDate', 'Local Time(UTC ' + timezoneOffset + ':00)'),
	makeLocallySortedAndPaginatedTableColumnHeader('TransactionId', 'TransactionID'),
	makeLocallySortedAndPaginatedTableColumnHeader('SubTransId', 'SubTransId')
];

function getData(getSimStatus, searchField, token) {
	var simId = searchField.simId;
	var transactionID = searchField.transactionID;
	const start = new Intl.DateTimeFormat(['ban', 'id']).format(searchField.startDate).replace('/', '-').replace('/', '-');
	const end = new Intl.DateTimeFormat(['ban', 'id']).format(searchField.endDate).replace('/', '-').replace('/', '-');
	var timeOffset = new Date().getTimezoneOffset();
	var allTime = searchField.allTime;

	const data = {
		'simId': simId,
		'transactionID': transactionID,
		'sDate': start,
		'eDate': end,
		'timeOffset': timeOffset,
		'allTime': allTime
	}

	getSimStatus('GET', SUPPORTCONSOLE_API_URL + '/api/simactivationdetail/v1/details', data, undefined, { 'Authorization': 'Bearer ' + token.token });
}

const SimActivationDetailPage = (props) => {
	const {
		token,
	} = props;

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const txid = urlParams.get('txid');
	const [ returnResult, statusc, runAjaxInner, responsec] = useAjax(XhrStatus.Initial);
	const [showAllTimeCheckBox, setShowAllTimeCheckBox] = useState(false);
	const [lastSearchSimId, setLastSearchSimId] = useState('');
	const [currentPage, setCurrentPage] = useState(1);
	const [hideDownload, setHideDownload] = useState(true);
	const [queryType, setQueryType] = React.useState(txid == null ? 'SimID' : 'TransactionID');
	const [errorState, setErrorState] = useState(false);
	const [searchErrorMessage, setSearchErrorMessage] = useState('');
	const [selectedFilter, setSelectedFilter] = useState('0');
	const [simFilter, setSimFilter] = useState('0');	
	const [pageresult, setResult] = useState([]);

	const filters = [
		{ label: 'All', value: '0' },
		{ label: 'Activated', value: '1' },
		{ label: 'Deactivated', value: '2' },
		{ label: 'Error', value: '3' },
		{ label: 'RatePlanChanged', value: '4' },
		{ label: 'ChangingRatePlan', value: '5' }
	];
	const simfilters = [
		{ label: 'All', value: '0' },
		{ label: 'AT&T', value: '1' },
		{ label: 'Verizon', value: '2' }
	];
	const initialSearchField = useMemo(() => {
		const date = new Date();
		return {
			startDate: new Date(date.setDate(date.getDate() - 7)),
			endDate: new Date(Date.now()),
			simId: '',
			transactionID: txid == null ? '' : txid,
			allTime: false
		};
	}, [txid]);
	
	const [searchField, updateFormValues] = useReducer(formUpdateFieldValues, initialSearchField);
	const [result, status, getSimStatus, response] = useAjax(XhrStatus.InProgress);

	const handleClick = useCallback(() => {
		const start_date = new Intl.DateTimeFormat(['ban', 'id']).format(searchField.startDate).replace('/', '-').replace('/', '-');
		const end_date = new Intl.DateTimeFormat(['ban', 'id']).format(searchField.endDate).replace('/', '-').replace('/', '-');
		var data; 
		setCurrentPage(1);
		setShowAllTimeCheckBox(true);
		setLastSearchSimId(searchField.simId);
		if (queryType === 'TransactionID')
		{
			data = prepareLogData(token,'Sim_Activity_Logs', 'Sim Activity Logs->Query TransactionId: ' + searchField.transactionID);
			setErrorState(true);
			if (searchErrorMessage == null)
			{
				getData(getSimStatus, searchField, token);
			}
		}
		else
		{
			data = prepareLogData(token,'Sim_Activity_Logs', 'Sim Activity Logs->Query SimId: ' + searchField.simId + ' StartDate:' + start_date + ' EndDate:' + end_date);
			getData(getSimStatus, searchField, token);
		}
			//Add activity log
			fetch(SUPPORTCONSOLE_API_URL + '/api/activity/v1/activitylog', {
				method: 'POST',
				headers: {
				  'Content-Type': 'application/json',
				  'Authorization': 'Bearer ' + token.token
				},
				body: JSON.stringify(data)
			  })	
	}, [getSimStatus, searchField, token, searchErrorMessage, queryType]);

	const handleCsvDownloadClick = () => {
		let cvsRows = (pageresult?.data) ? pageresult.data.map(item => makeJsonRow(item)) : [];
		fileDownload('SimId,Carrier,Status,UTCDate,LocalStartTime,LocalDate,TransactionID,StatusDescription' + cvsRows.join(''), 'SimLogEx.csv');
	}
	useEffect(
		() => {
			// If useAjax(XhrStatus.InProgress) and not login yet, it will show 401
			// So we need to make sure token is avaliable to continue...
			if (token?.token) {
				getData(getSimStatus, initialSearchField, token);
			}
		},
		[getSimStatus, initialSearchField, token]
	);


	useEffect(
		() => {
			if (searchField.simId !== '' && searchField.simId === lastSearchSimId) {
				setShowAllTimeCheckBox(true);
			}
			else {
				setShowAllTimeCheckBox(false);
				searchField.allTime = false;
			}

			if (searchField.allTime === true && searchField.simId === lastSearchSimId) {
				getData(getSimStatus, searchField, token);
			}

		}, [getSimStatus, searchField, token, lastSearchSimId, showAllTimeCheckBox]
	);

	useEffect(
		() => {
			setErrorState(false);
			if (queryType === 'SimID') {
				searchField.transactionID = '';
			}
			else if (queryType === 'TransactionID') {
				searchField.simId = '';
			}
		},
		[queryType, searchField]
	);

	function makeRow(task) {
		const {
			transactionId,
			simId,
			status,
			statusDesc,
			date,
			localDate,
			subRows
		} = task;
		return {
			key: transactionId,
			columns: [
				{
					key: 'SimId',
					columnContent: simId
				},
				{
					key: 'Status',
					columnContent: status
				},
				{
					key: 'StatusDescription',
					columnContent: statusDesc
				},
				{
					key: 'Date',
					columnContent: date
				},
				{
					key: 'LocalDate',
					columnContent: localDate
				},
				{
					key: 'TransactionID',
					columnContent: transactionId
				},
				{
					key: 'SubTransId',
					columnContent: ' '
				}
			],

			htmlAttributes: {
				className: status.startsWith('Error') ? 'error-row' : ''
			},
			subRows:
				subRows.filter(item => item.date !== date).map(subRow => {
					return {
						key: uuidv4(),
						columns: [
							{
								key: 'SimId',
								columnContent: ' '
							},
							{
								key: 'Status',
								columnContent: subRow.status
							},
							{
								key: 'StatusDescription',
								columnContent: subRow.statusDesc
							},
							{
								key: 'Date',
								columnContent: subRow.date
							},
							{
								key: 'LocalDate',
								columnContent: subRow.localDate
							},
							{
								key: 'TransactionID',
								columnContent: ' '
							},
							{
								key: 'SubTransId',
								columnContent: subRow.subtransId
							}
						]
					};
				})
		};
	}
	// Convert date string to ISO 8601 format
	function convertToISO(dateStr) {
		// Split the date and time parts
		const [date, time] = dateStr.split(' ');
  
		// Replace slashes with hyphens in the date part
		const isoDate = date.replace(/\//g, '-');
  
		// Combine the date and time parts with a "T" separator
		return `${isoDate}T${time}`;
  	}
	function makeJsonRow(task) {
		const {
		  transactionId,
		  simId,
		  status,
		  statusDesc,
		  date,
		  localDate,
		  subRows
		} = task;
	  
		let carrier = '';
		let localStartTime = '';
	  
		if (simId.startsWith('89148')) {
		  carrier = 'VZN';
		} else if (simId.startsWith('890117')) {
		  carrier = 'ATT';
		}
	  
		if (status === 'Activated' || status === 'Deactivated') {
		  let activatingSubRows = subRows.filter(row => row.status === 'Activating' || row.status === 'Deactivating');
		  if (activatingSubRows.length > 0) {
			activatingSubRows.sort((a, b) => new Date(convertToISO(a.localDate)) - new Date(convertToISO(b.localDate)));
			console.log(activatingSubRows);
			localStartTime = activatingSubRows[0].localDate;
		  }
		}
	  
		return `\n${simId},${carrier},${status},${date},${localStartTime},${localDate},${transactionId},${statusDesc}`;
	}
	  
	const rows = useMemo(
		() => {
			let newdata = {... result};
			if (result != null)
			{
				if (selectedFilter === '1' ) //Activate
				{
					newdata.data = newdata.data.filter(item=>item.status.includes('Activated'));
					
				}
				else if (selectedFilter === '2' ) //Deactivate
				{
					newdata.data = newdata.data.filter(item=>item.status.includes('Deactivated'));
				}
				else if (selectedFilter === '3' ) //Error
				{
					newdata.data = newdata.data.filter(item=>item.status.includes('Error'));
				}
				else if (selectedFilter === '4' ) //RatePlanChanged
				{
					newdata.data = newdata.data.filter(item=>item.status.includes('RatePlanChanged'));
				} 
				else if (selectedFilter === '5' ) //ChangingRatePlan
				{
					newdata.data = newdata.data.filter(item=>item.status.includes('ChangingRatePlan'));
				}   
				else
				{
					//ALL
				}

				if (simFilter === '1' ) //ATT
				{
					newdata.data = newdata.data.filter(item=>item.simId.startsWith('890117'));
					
				}
				else if (simFilter === '2' ) //VZN
				{
					newdata.data = newdata.data.filter(item=>item.simId.startsWith('89148'));
				} else
				{
					//ALL
				}
			}
			const Rows = (newdata?.data) ? newdata.data.map(item => makeRow(item)) : [];
			if (Rows.length > 0) {
				setHideDownload(false);
			}
			else {
				setHideDownload(true);
			}
			setResult(newdata);
			setCurrentPage(1);
			return Rows;
		},
		[result,simFilter,selectedFilter]
	);
	
	return (
		<Card
			htmlAttributes={{
				id: 'sim-activation-detail-page'
			}}
		>
			<RestfulCallout status={status} response={response} returnObj={result} hideSuccess={true} />
			<div className='panel-radio-options'>
					<RadioOptions
						label="SimID"
						fieldName="simID-radio"
						value={queryType === 'SimID'}
						onChange={() => {setQueryType('SimID')}}
					/>
					<RadioOptions
						label="TransactionID"
						fieldName="transactionID-radio"
						value={queryType === 'TransactionID'}
						onChange={() => {setQueryType('TransactionID')}}
					/>
			</div>
			{ queryType === 'SimID' ? 
				(<div className="Input-field">
					<InputField
						inputType="text"
						fieldName="simId"
						label="SimID"
						htmlAttributes={{
							onChange: updateFormValues,
							value: searchField.simId
						}}
					/>
					<div>
						<span>Start Date </span>
						<DateTimePicker
							inputFieldAttributes={{
								fieldName: 'startDate'
							}}
							value={searchField.startDate}
							onChange={updateFormValues}
							allowDateToBeCleared={false}
							disabled={searchField.allTime}
						/>
					</div>
					<div>
						<span>End Date </span>
						<DateTimePicker
							inputFieldAttributes={{
								fieldName: 'endDate'
							}}
							value={searchField.endDate}
							onChange={updateFormValues}
							allowDateToBeCleared={false}
							disabled={searchField.allTime}
						/>
					</div>
					<div style={{ width: '11em' }}>
					<Dropdown
						fieldName="selectedfilter"
						label="Status"
						options={filters}
						htmlAttributes={{
							onChange: update => {
								setSelectedFilter(update.value);
							},
							value: selectedFilter,
						}}
						reactSelectOptions={{ menuPlacement: 'auto' }}
					/>
					</div>
					<div>
					<Dropdown
						fieldName="simfilter"
						label="MNO"
						options={simfilters}
						htmlAttributes={{
							onChange: update => {
								setSimFilter(update.value);
							},
							value: simFilter,
						}}
						reactSelectOptions={{ menuPlacement: 'auto' }}
					/>
					</div>
					<PrimaryButton
						onClick={handleClick}>
						<TranslatedString stringId="Search" />
					</PrimaryButton>
					{showAllTimeCheckBox ? (
						<Checkbox
							fieldName="allTime"
							label="All Time"
							htmlAttributes={{
								onChange: updateFormValues,
								checked: searchField.allTime ?? false
							}}
						/>) : null
					}
					
				</div>) : 
				<div className="Input-field">
					<InputField
						inputType="text"
						fieldName="transactionID"
						label="TransactionID"
						shouldAlwaysShowErrors={errorState}
						validationError={searchErrorMessage}
						onValidationError={(update) => {
							setSearchErrorMessage(update.value);
						}}
						htmlAttributes={{
							onChange: updateFormValues,
							value: searchField.transactionID,
							required: true
						}}
					/>
					<PrimaryButton
						onClick={handleClick}>
						<TranslatedString stringId="Search" />
					</PrimaryButton>
				</div>
			}
			{
				<LocallySortedAndPaginatedTable
					headers={TABLE_HEADERS}
					rows={rows}
					numRowsPerPage={100}
					currentPage={currentPage}
					goToPageFunc={setCurrentPage}
					htmlAttributes={{
						className: 'sim-activation-detail-table'
					}}
					errorMessage="Error occured"
					noResultsMessage={<TranslatedString stringId="No Sim Data found" />}
				/>

			}
			<CommandBar
				actions={
					<div>
						<PrimaryButton type="submit" style={{ display: hideDownload === true ? 'none' : 'inline' }}
							onClick={handleCsvDownloadClick}>Download</PrimaryButton>
					</div>
				}
			/>

			<RestfulCallLoading status={status} />
		</Card>
	);
};

export default withErrorHandler(React.memo(SimActivationDetailPage));
